import ProceduralBackground from '../games/ProceduralBackground';

const baseStyle = {
  position: 'absolute',
  inset: 0,
  zIndex: 0,
  background: '#BDEFF4',
  pointerEvents: 'none',
};

const skywashStyle = {
  position: 'absolute',
  inset: 0,
  zIndex: 1,
  pointerEvents: 'none',
  background:
    'radial-gradient(circle at 50% 28%, rgba(255, 255, 255, 0.68), transparent 27%),' +
    'linear-gradient(180deg, rgba(194, 245, 244, 0.72) 0%, rgba(194, 245, 244, 0.22) 52%, rgba(105, 224, 174, 0.45) 100%)',
};

export default function AuthBackground() {
  return (
    <>
      <div aria-hidden="true" style={baseStyle} />
      <ProceduralBackground
        rendererKey="skyClouds"
        isAnimating={false}
        style={{ opacity: 0.88, zIndex: 0 }}
      />
      <div aria-hidden="true" style={skywashStyle} />
    </>
  );
}
